<template>
    <p v-if="title" class="text-white text-size2 font-normal leading-6">
        &copy; {{title}}
    </p>
</template>

<script>
    export default {
        name: "Copyright",
        props: ['title']
    }
</script>

<style scoped>

</style>